import React from 'react'
import CardPage from '../../../layout/CardPage'
import { Forma } from './_Forma'

export const ReporteXls = () => {
  return (
    <CardPage titulo="Reporte XLS">
    
    <Forma />
   
  </CardPage>
  )
}
